<template>
	<div class="pxrwwfgv-screen-sikvidek">
		<drawer-menu title="Síkvidék" />
		<DraggingIntervention />
		<DropSpots />
		<GameControls />
	</div>
</template>

<script setup >
	import {useStore} from 'vuex';

	import DrawerMenu from './ScreenGame/DrawerMenu.vue';
	import DraggingIntervention from './ScreenGame/DraggingIntervention.vue';
	import DropSpots from './ScreenGame/DropSpots.vue';
	import GameControls from './ScreenGame/GameControls.vue';

	const store = useStore();

	store.dispatch('setEndVideos', [
		require('@/assets/videos/sv_failure.webm'),
		require('@/assets/videos/sv_normal.webm'),
		require('@/assets/videos/sv_success.webm'),
	]);

	store.dispatch('setInterventions', [
		{
			id: 1,
			title: 'erdősítés és gyepesítés',
			desc: 'Az erdő és a gyep a szántónál jobban bírja és hasznosítja a főként tavasszal megjelenő belvizet.',
			thumbnail: require('@/assets/images/icons/ikon_SV_01_erdosites.svg'),
			correctLocations: [3,2],
		},
		{
			id: 2,
			title: 'természetközeli víztározó',
			desc: 'A tározó pufferterületként szolgál az időszakos többletvizek helyben tartására és talajba szivárogtatására.',
			thumbnail: require('@/assets/images/icons/ikon_SV_02_t.viztarozo.svg'),
			correctLocations: [2,3],
		},
		{
			id: 3,
			title: 'esőkert',
			desc: 'Az esőkert a csapadék elszikkasztását segítő, növényekkel beültetett, lemélyített zöldfelület egy településen.',
			thumbnail: require('@/assets/images/icons/ikon_SV_03_esokert.svg'),
			correctLocations: [4],
		},
		{
			id: 4,
			title: 'csatornalezárás zsilippel',
			desc: 'A belvízcsatornák zsilipekkel szakaszosan lezárva a belvíz tározásában is szerepet kaphatnak.',
			thumbnail: require('@/assets/images/icons/ikon_SV_04_zsilip.svg'),
			correctLocations: [5,6],
		},
		{
			id: 5,
			title: 'mezővédő erdősáv',
			desc: 'A táblák közötti erdősávok védenek a széltől, mérséklik a kiszáradást, javítják a mikroklímát.',
			thumbnail: require('@/assets/images/icons/ikon_SV_05_erdosav.svg'),
			correctLocations: [1],
		},
		{
			id: 6,
			title: 'holtág-visszacsatolás',
			desc: 'Ha a holtágat újra összekötjük a folyóval a holtágba juttatott víz az egész környék vízháztartását javítja.',
			thumbnail: require('@/assets/images/icons/ikon_SV_06_holtag.svg'),
			correctLocations: [7],
		},
	]);

	store.dispatch('setDropSpots', [
		{
			id: 1,
			coords: [800,151],
		},
		{
			id: 2,
			coords: [1122,273],
		},
		{
			id: 3,
			coords: [1240,434],
		},
		{
			id: 4,
			coords: [408,469],
		},
		{
			id: 5,
			coords: [949,570],
		},
		{
			id: 6,
			coords: [1500,570],
		},
		{
			id: 7,
			coords: [1500,779],
		},
	]);
</script>

<style scoped>
	.pxrwwfgv-screen-sikvidek {
		background-image: url('@/assets/images/background_sikvidek.svg');
		/*background-image: url('@/assets/images/background_SV_drop_spots.svg');*/
	}
</style>